const getters = {
	dataInfo: state => state.examInfo.data.data,
	winRate: state => parseInt(state.examInfo.data.data.winRate*10),
	greyRate: state => 10-parseInt(state.examInfo.data.data.winRate*10),
	examDate: state => {
		let m = state.examInfo.data.data.examDate || new Date()
		let s = new Date(m)
		s = (s.getFullYear()+'/'+(s.getMonth()+1)+'/'+s.getDate()).split('/')
		let dateF = s[0]+(s[1].length===1? '/0'+s[1]:'/'+s[1])+(s[2].length===1? '/0'+s[2]:'/'+s[2])
		return dateF
	},
	token:state => state.examInfo.accessToken,
	examInfoId:state => state.examInfo.examInfoId,
	examInfoType:state => state.examInfo.examInfoType,
	loading:state => state.loading.show,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js